import { render } from "./InvoiceStatus.vue?vue&type=template&id=715be1de&scoped=true"
import script from "./InvoiceStatus.vue?vue&type=script&lang=js"
export * from "./InvoiceStatus.vue?vue&type=script&lang=js"

import "./InvoiceStatus.vue?vue&type=style&index=0&id=715be1de&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-715be1de"]])

export default __exports__